<template>

  <div id="modal">
    <div class="container-fluid">
      <p class="linespace95"></p>

      <div class="row">
	<div class="col-12">
	  <div class="centertext">
	    <p class="linespace45"></p>
	    <p class="linespace65"></p>
	  </div>
	</div>
      </div>
      <div class="container">
	<div class="row">
	  <div class="col"> </div>
	  <div class="col-auto"> 
	    <div class="container-fluid">
	      <div class="row">
		<div class="col-6">
		  <div class="centerbox">
		    <router-link to="./searchactivation.html">
		      <div class="greenbtnL">Search Activation<br>Code</div>
		    </router-link>
		  </div>
		</div>
		<div class="col-6">
		  <div class="centerbox">
		    <router-link to="./generateactivation.html">
		      <div class="greenbtnL">Generate<br>Activation Code</div>
		    </router-link>
		  </div>
		</div>
	      </div>
	    </div>
	  </div>
	  <div class="col"> </div>
	</div>
	<div class="row linespace25">
	  <div class="col"> </div>
	  <div class="col-auto"> 
	    <div class="container-fluid">
	      <div class="row">
		<div class="col-6">
		  <div class="centerbox">
		    <router-link to="./product.html">
		      <div class="greenbtnL">Product<br>Management</div>
		    </router-link>
		  </div>
		</div>
		<div class="col-6">
		  <div class="centerbox">
		    <router-link to="./menu.html">
		      <div class="greenbtnL">Close</div>
		    </router-link>
		  </div>
		</div>
	      </div>
	    </div>
	  </div>
	  <div class="col"> </div>
	</div>
      </div>
      <p class="linespace10"></p>
      <p class="linespace45"></p>
      <p class="linespace65"></p>

    </div>
  </div>

</template>

<script setup>
import { checkMaintenance } from '../server';

checkMaintenance();

</script>

<style scoped>
</style>
